export type NotificationCategory =
  | 'daily_ready'
  | 'snooze'
  | 'weekly_review'
  | 'coach_update'
  | 'occasion'

export interface NotificationCategorySettings {
  daily_ready: boolean
  snooze: boolean
  weekly_review: boolean
  coach_update: boolean
  occasion: boolean
}

export interface NotificationSettingsView {
  enabled: boolean
  categories: NotificationCategorySettings
  quietStart: string
  quietEnd: string
  dailyTime: string
  weeklyDay: number
  weeklyTime: string
  timeZone: string
  preview: 'neutral'
  activeInstallationCount: number
  schemaVersion: 'pmm-notification-settings-1'
}

export interface NotificationSettingsUpdate {
  enabled: boolean
  categories: NotificationCategorySettings
  quietStart: string
  quietEnd: string
  dailyTime: string
  weeklyDay: number
  weeklyTime: string
  timeZone: string
}

export interface PushInstallationRegistration {
  installationId: string
  platform: 'ios' | 'android' | 'desktop' | 'unknown'
  timeZone: string
}

export interface NotificationTestResult {
  state: 'sent' | 'duplicate' | 'no_active_installation' | 'disabled'
  successfulDeliveries: number
}

export const defaultNotificationSettings = (timeZone = 'Australia/Brisbane'): NotificationSettingsView => ({
  enabled: false,
  categories: {
    daily_ready: true,
    snooze: true,
    weekly_review: true,
    coach_update: true,
    occasion: false,
  },
  quietStart: '20:30',
  quietEnd: '07:00',
  dailyTime: '07:30',
  weeklyDay: 0,
  weeklyTime: '18:00',
  timeZone,
  preview: 'neutral',
  activeInstallationCount: 0,
  schemaVersion: 'pmm-notification-settings-1',
})
